import * as React from "react";
import styled from "../../../styled/index";
import { RestaurantIcon, RestaurantIconList } from "../../elements/restaurant.icon/index";
import { CS } from "../../../styles/index";
const Wrapper = styled("div") `
  display: flex;
  flex-wrap: wrap;
`;
const Icon = styled("div") `
  ${CS.flex.center};
  width: 50px;
  height: 50px;
  border: 1px solid ${({ theme }) => theme.input.border};
  cursor: pointer;
  font-size: 32px;
  &:hover, &.active {
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary_text};
  }
`;
const dish_tags = [
    { i: 'baked' },
    { i: 'baked2' },
    { i: 'dairy_free' },
    { i: 'dairy_free2' },
    { i: 'dairy_free3' },
    { i: 'dessert' },
    { i: 'dessert2' },
    { i: 'gluten_free' },
    { i: 'gluten_free2' },
    { i: 'gluten_free3' },
    { i: 'rsz_2allergy_warning_2' },
    { i: 'rsz_allergy_warning' },
    { i: 'vegan' },
    { i: 'vegan2' },
    { i: 'vegan3' },
    { i: 'vegan4' },
    { i: 'vegan5' },
    { i: 'vegan6' },
    { i: 'woodfire' },
    { i: 'woodfire2' },
    { i: 'halal1' },
    { i: 'halal2' },
    { i: 'halal3' },
];
export const RestaurantIconSelect = (props) => (React.createElement(Wrapper, null,
    Object.keys(RestaurantIconList).map((key) => (React.createElement(Icon, { key: key, onClick: () => props.onChange(key), className: props.selected === key ? "active" : "" },
        React.createElement(RestaurantIcon, { icon: key })))),
    dish_tags.map((item, i) => (React.createElement(Icon, { key: i, onClick: () => props.onChange(item.i), className: props.selected === item.i ? "active" : "" },
        React.createElement("img", { key: i, src: `/images/dish_tags/${item.i + '.png'}`, alt: item.i.includes('halal') ? 'Halal icons created by Hilmy Abiyyu A. - Flaticon' : '' }))))));
//# sourceMappingURL=index.js.map